import { createFormHook } from "@tanstack/react-form";

import { AlbInput } from "./albInput";
import { CheckboxField } from "./checkboxField";
import { DateTimeField } from "./dateField";
import { DriverAutocomplete } from "./driverAutocomplete";
import { fieldContext, formContext } from "./form.context";
import { GenericAsyncAutocomplete } from "./genericAsyncAutocomplete";
import { NumberField } from "./numberField";
import { PhoneField } from "./phoneField";
import { PriceField } from "./priceField";
import { PricingSliderField } from "./pricingSliderField";
import { SelectField } from "./selectField";
import { SwitchField } from "./switchField";
import { TextField } from "./textField";

export { GenericAsyncAutocomplete };

export const { useAppForm, withForm, useTypedAppFormContext } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    AlbInput,
    CheckboxField,
    DateTimeField,
    DriverAutocomplete,
    NumberField,
    PhoneField,
    PriceField,
    PricingSliderField,
    SelectField,
    SwitchField,
    TextField,
  },
  formComponents: {},
});
